import { j as o } from "../jsx-runtime-ClSzPYp4.js";
import { animated as w, useTransition as z } from "@react-spring/web";
import { F as D } from "../focus-trap-react-Bogv-_bG.js";
import { createPortal as E } from "react-dom";
import { styled as m } from "styled-components";
import { width as L } from "styled-system";
import { Box as P } from "../Flexbox/Flexbox.mjs";
import "../index.esm-DOxVcNnO.js";
import "../Icon/StyledPath.mjs";
import G from "../Icon/Icons/CrossIcon.mjs";
import { noOp as H } from "../common/utils/index.mjs";
import { OuterWrapper as J, Backdrop as K, CloseButton as N, ModalIcon as Q, ModalHeading as S, ModalDivider as U } from "./components.mjs";
import V from "./useModal.mjs";
const X = /* @__PURE__ */ m(w(P)).withConfig({
  componentId: "sc-85f3dac4-0"
})([
  "",
  " ",
  ""
], ({ theme: a }) => a.components.modal.base, L), Y = /* @__PURE__ */ m.div.withConfig({
  componentId: "sc-85f3dac4-1"
})([
  "",
  ""
], ({ theme: a }) => a.components.modal.innerWrapper), po = ({ id: a, ariaDescribedById: c, children: p, heading: d, Icon: n, isOpen: e, rootId: f, onClose: u = H, parentModalId: x, allowDismiss: i = !0, allowClickAway: j = !0, showDivider: I = !1, disableFocusTrap: b = !1, showHeading: t = !0, modalWrapperProps: h, animationOptions: C = {}, ModalWrapper: $ = Y, ModalContentWrapper: g = X, ...k }) => {
  const { modalRef: q, handleClose: l } = V(e, u, i, f, x), v = {
    "aria-describedby": c,
    "aria-label": t ? void 0 : d,
    "aria-labelledby": t ? `modal-heading-${a}` : void 0
  }, M = `modal-wrapper-${a}`, y = `modal-backdrop-${a}`, r = `modal-container-${a}`, B = `modal-close-button-${a}`, F = `modal-icon-${a}`, s = `modal-heading-${a}`, W = `modal-divider-${a}`, T = z(e, C);
  return /* @__PURE__ */ o.jsx(o.Fragment, {
    children: T((A, O) => O && /* @__PURE__ */ o.jsx(o.Fragment, {
      children: /* @__PURE__ */ E(/* @__PURE__ */ o.jsx(D, {
        active: !b,
        focusTrapOptions: {
          fallbackFocus: `#${r}`
        },
        children: /* @__PURE__ */ o.jsx(J, {
          ...v,
          role: "dialog",
          id: a,
          "data-qa-id": M,
          ...k,
          children: /* @__PURE__ */ o.jsxs($, {
            children: [
              /* @__PURE__ */ o.jsx(K, {
                "aria-hidden": !0,
                "data-qa-id": y,
                onClick: (R) => {
                  j && l(R);
                }
              }),
              /* @__PURE__ */ o.jsxs(g, {
                style: A,
                ref: q,
                tabIndex: -1,
                id: r,
                "data-qa-id": r,
                ...h,
                children: [
                  i && /* @__PURE__ */ o.jsxs(N, {
                    variant: "textLinkInline",
                    "data-qa-id": B,
                    onClick: l,
                    children: [
                      "Close",
                      /* @__PURE__ */ o.jsx(G, {
                        verticalAlign: [
                          "bottom",
                          null,
                          "text-top"
                        ],
                        pl: "xs",
                        size: [
                          16,
                          null,
                          20
                        ]
                      })
                    ]
                  }),
                  n && /* @__PURE__ */ o.jsx(Q, {
                    "data-qa-id": F,
                    as: n
                  }),
                  t && /* @__PURE__ */ o.jsx(S, {
                    id: s,
                    "data-qa-id": s,
                    children: d
                  }),
                  I && /* @__PURE__ */ o.jsx(U, {
                    "data-qa-id": W
                  }),
                  p
                ]
              })
            ]
          })
        })
      }), document.body)
    }))
  });
};
export {
  po as Modal,
  X as ModalContent,
  Y as ModalInnerWrapper
};
